

import { getState } from "../store"
import moment from "moment";
import { TSteps } from "../reducers/appReducers"

interface IStepConfig {
    nextStep: TSteps
    prevStep: TSteps
    progress: number
}

class StepHandler {
    currentStep: TSteps = "BasicInfo" // fist step

    getStepConfig = (): IStepConfig => {

        const flow: TSteps[] = ["BasicInfo", "AddressInfo", "WorkStatus", "ArtistStatus", "Dashboard", "Declaration", "Complete"]
        const { userInfo } = getState()
        const { step } = getState().app
        const { activeCountry = "SG" } = userInfo
        const minAge = getState().config?.appConfig?.countryConfig[activeCountry.toUpperCase()]?.minAge ?? 18;
        const isJunior = userInfo["dateOfBirth"] && moment(userInfo["dateOfBirth"]).isAfter(moment().subtract(minAge, "year"));

        const stepConfig: IStepConfig = {
            nextStep: null,
            prevStep: null,
            progress: 0
        }

        // If is younger than min age add ParentInfo step
        if (isJunior) flow.splice(1, 0, "ParentInfo")

        // Condition for views not in application flow
        if (!flow.includes(step)) {
            stepConfig.prevStep = this.currentStep
            stepConfig.nextStep = flow[flow.findIndex(s => s === this.currentStep) + 1]
            stepConfig.progress = flow.findIndex(s => s === this.currentStep) / (flow.length - 1) * 100
            return stepConfig
        } else {
            this.currentStep = step
        }

        stepConfig.nextStep = flow[flow.findIndex(s => s === step) + 1]
        stepConfig.prevStep = flow[flow.findIndex(s => s === step) - 1]
        stepConfig.progress = flow.findIndex(s => s === step) / (flow.length - 1) * 100

        // If prevStep is not able to be back return null instead
        // if (stepConfig.prevStep === "BasicInfo") stepConfig.prevStep = null

        return stepConfig
    }
}

const stepHandler = new StepHandler()

export default stepHandler.getStepConfig